module.exports = __webpack_public_path__ + "static/media/spacedunk-packshot.aa36fbdb.png";